import { useEffect } from 'react'
import { fetchCruiseDeals } from 'actions/CruiseActions'
import { useAppDispatch, useAppSelector, shallowEqual } from 'hooks/reduxHooks'

export interface UseCruiseDeals {
  deals: Array<App.Cruises.CruiseDealBase>
  isLoading: boolean
}

export function useCruiseDeals(): UseCruiseDeals {
  const dispatch = useAppDispatch()
  const { deals, fetching } = useAppSelector((state) => ({
    deals: state.cruise.cruiseDeals,
    fetching: state.cruise.fetchingCruiseDeals,
  }), shallowEqual)

  useEffect(() => {
    dispatch(fetchCruiseDeals())
  }, [dispatch])

  return {
    deals,
    isLoading: fetching,
  }
}
